import styles from "./config.module.scss";
import { downloadDocument, formatTimeStamp } from "../helpers/generel.helpers";

export const columns = [
  {
    field: "updated_at",
    headerName: "Date",
    renderCell: (row) => formatTimeStamp(row.updated_at),
  },
  {
    field: "plan_type",
    headerName: "Plan",
  },
  {
    field: "sum",
    headerName: "Amount",
  },
  {
    field: "",
    renderCell: (row) => (
      <div className="flex" onClick={() => downloadDocument(row.id)}>
        <button className={styles.downloadbtn}>Download Invoice</button>
      </div>
    ),
  },
];
